import type { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { getBuilderModelName } from "@/libs/builder/tools/getBuilderModelName";
import { createSticksProductDefaultDataBinding } from "@/libs/commerce/SticksProductContent";

import type { STICKS_PRODUCT_DETAILS_CONTAINER_BINDINGS_INPUTS } from "./SticksProductDetailsContainer.inputs.builder";
import { ALL_STICKS_PRODUCT_DETAILS_CONTAINER_INPUTS } from "./SticksProductDetailsContainer.inputs.builder";

export const SticksProductDetailsContainerComponent: RegisteredComponent = {
  name: "SticksProductDetailsContainer",
  friendlyName: "Sticks Product Details Container",
  component: dynamic(async () => (await import("./SticksProductDetailsContainer")).SticksProductDetailsContainer),
  models: [getBuilderModelName("product")],
  defaults: {
    bindings: createSticksProductDefaultDataBinding<typeof STICKS_PRODUCT_DETAILS_CONTAINER_BINDINGS_INPUTS>({
      sku: "productSku",
      badgeText: "productBadgeText",
      description: "productDescription",
      shortDescription: "productShortDescription",
      knowMoreUrl: "productKnowMoreUrl",
      multiPackDescription: "productMultiPackDescription",
      productName: "productName",
      isCommerceDisabled: "productIsCommerceDisabled",
      isMultiPackEnabled: "productIsMultiPackEnabled",
      multiPackName: "productMultiPackName",
      multiPackProducts: "productMultiPackProducts",
      customBuyCtaLabel: "productCustomBuyCtaLabel",
      isSubscriptionsEnabled: "productIsSubscriptionsEnabled",
      sticksMatrixData: "productSticksMatrixData",
    }),
  },
  inputs: ALL_STICKS_PRODUCT_DETAILS_CONTAINER_INPUTS,
};
